import { render } from "./legend.vue?vue&type=template&id=a65389d0&scoped=true"
import script from "./legend.vue?vue&type=script&lang=js"
export * from "./legend.vue?vue&type=script&lang=js"

import "./legend.vue?vue&type=style&index=0&id=a65389d0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a65389d0"]])

export default __exports__